module.exports = __webpack_public_path__ + "img/registration-bg-image.aa12d238.png";